export default __webpack_public_path__ + "static/media/login-tokoo.0c146f23.svg";